/** @format */

import queryString from 'query-string';
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';

/** @format */
const Pagination = ({ totalPage, basePath, search = null }) => {
  const navigate = useNavigate();
  const params = queryString.parse(search);
  const pageParam = params.page;

  const pageSet = (pageCount) => {
    let page = '';
    page = search?.replace(new RegExp(/([(\?|\&)]+)page=([0-9]+)/, 'g'), '');
    page = page.replace('?', '');
    page += search?.length > 0 ? '&' : '';
    page += 'page=' + pageCount;
    return page;
  };

  return (
    <div className='w-100 mt-4 d-flex'>
      {/*<Pagination meta={eventContext.users.meta} />*/}
      <ReactPaginate
        breakLabel='...'
        nextLabel='بعدی'
        pageRangeDisplayed={5}
        pageCount={totalPage}
        previousLabel='قبلی'
        initialPage={pageParam == null ? 0 : parseInt(pageParam) - 1}
        pageClassName='c-pointer'
        pageLinkClassName='page-link'
        activeLinkClassName='active-page'
        previousLinkClassName='page-link'
        nextLinkClassName='page-link'
        disabledLinkClassName='disable-page'
        onClick={(page) => {
          return navigate(
            page.event.target.href.replace(window.location.origin, ''),
          );
        }}
        hrefBuilder={(page, pageCount, selected) =>
          page >= 1 && page <= pageCount ? `${basePath}?${pageSet(page)}` : '#'
        }
        containerClassName='d-flex flex-row align-items-center list-style-none justify-content-center w-100'
        renderOnZeroPageCount={null}
      />
    </div>
  );
};

export default Pagination;
